import React, { useState } from 'react'
import { navigate } from 'gatsby'

const Landing = ({ video, mobileVideo }) => {

  const enterSiteHandle = (e) => {
    e.preventDefault();
    navigate('/home/');
  }

  return (
    <section className='landing'>
      <video src={mobileVideo} loop muted autoPlay playsInline className="landing__video landing__video--mobile" />
      <video src={video} loop muted autoPlay playsInline className="landing__video landing__video--desktop" />
      <div className="landing__welcome">
        <div className="landing__enter">
          <span>Enter Site</span>
        </div>
      </div>
      <button onClick={enterSiteHandle} />
    </section>
  );
};

export default Landing